import { FormControl, Grid, Paper, TextField } from "@mui/material";
import { MRT_ColumnDef } from "material-react-table";
import { useEffect, useMemo, useState } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import { IFilteringViewModel } from "../../_common/interface/table";
import StyledGrid from "../grid/styledGrid";
import { PageHeader } from "../header/page.header";
import { CommonTable } from "../table/common.table";
import { toastr } from "../toastr/toastr";
import { handleErrorResponse } from "../../_helpers/handleResponse.helper";
import { useContainerStyles } from "../../_styles/container.styles";
import moment from "moment";
import { EmailTemplateManageDrawer } from "./emailTemplate-manageDrawer";
import { emailtemplateService } from "../../_services/emailTemplate.service";


export function EmailTemplateIndex() {

    const [data, setData] = useState({ items: [], count: 0 });
    const [selectedId, setSelectedId] = useState<number | null>(null);
    const [isLoading, setLoading] = useState(false);
    const [filter, setFilter] = useState<IFilteringViewModel>({
        name: '',
    });

    const columns = useMemo<MRT_ColumnDef<any>[]>(
        () => [
            {
                accessorKey: 'subject',
                header: 'Subject',
            },
            {
                accessorKey: 'body',
                header: 'Body',
            },
            {
                accessorKey: 'name',
                header: 'Name',
            },
            {
                accessorKey: 'emailTypeId',
                header: 'Email Type',
            },
        ],
        [],
    );

    useEffect(() => {
        fetchData();
    }, [filter]);

    function fetchData() {

        return emailtemplateService.getAll({ ...filter })
            .then(
                json => {
                    setData({ ...json, _value: (json.value + "%"), startDate: moment(json.startDate).format('DD/MM/YYYY'), expiryDate: moment(json.expiryDate).format('DD/MM/YYYY') });
                }, handleErrorResponse)
            .finally(() => {
                setLoading(false);
            });
    }

    function onDelete(id: number) {
        setLoading(true);
        return emailtemplateService
            .disable(id)
            .then(
                () => {
                    fetchData();
                    toastr.success("EmailTemplate Type disabled successfully");
                }, handleErrorResponse
            )
            .finally(() => setLoading(false));
    }

    function handleChange(event: any) {
        setFilter((__filter: any) => { return { ...__filter, [event.target.name]: event.target.value } });
    };

    return (

        <>
            <div style={useContainerStyles.root}>

                <PageHeader
                    pageName="EmailTemplates"
                    buttonName="EmailTemplate"
                    onClick={() => setSelectedId(0)}
                    actionType="create"
                />

                <Paper>

                    <ValidatorForm onSubmit={fetchData}>

                        <StyledGrid container spacing={2}>

                            <Grid item lg={3} md={6} xs={12}>
                                <FormControl fullWidth>
                                    <TextField label="Name" name="name" value={filter.name} onChange={handleChange} placeholder="Name" variant="outlined" />
                                </FormControl>
                            </Grid>

                        </StyledGrid>

                    </ValidatorForm>

                    <CommonTable
                        columns={columns}
                        data={data}
                        onEdit={setSelectedId}
                        filter={filter}
                        setFilter={(_filter) => { setFilter({ ...filter, ..._filter }) }}
                        isLoading={isLoading}
                    />

                    <EmailTemplateManageDrawer
                        isOpen={selectedId != null}
                        itemId={selectedId}
                        onSave={() => { setSelectedId(null); fetchData(); }}
                        onClose={() => { setSelectedId(null); fetchData(); }}
                    />

                </Paper>

            </div>
        </>


    );

}
